import React from "react"
import styled from "styled-components"
export const LiveStream: React.FC = ({ data }) => {
  return (
    <StyledDiv style={{display: data.attrs.hidden ? "none":"grid"}}>
      <div dangerouslySetInnerHTML={{ __html: data.attrs.video }}>{/* test */}</div>
      <div dangerouslySetInnerHTML={{ __html: data.attrs.chat }} style={{ minHeight: 500, height: 500 }}></div>
    </StyledDiv>
  )
}

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 40px;
  margin-bottom: 70px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
